import React from "react";
import { AnimatePresence } from "framer-motion";

class NoSSRAnimatePresence extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isClient: false,
		};
	}

	componentDidMount() {
		this.setState({ isClient: true });
	}

	render() {
		const { children, ...rest } = this.props;

		// On server, render children without animation wrapper
		if (!this.state.isClient) {
			// Return first child or array of children
			return React.Children.count(children) === 1 ? React.Children.only(children) : <>{children}</>;
		}

		// On client, render with AnimatePresence
		return <AnimatePresence {...rest}>{children}</AnimatePresence>;
	}
}

export default NoSSRAnimatePresence;
